import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import CertificateManage from '../views/CertificateManage.vue'
import ArtistManage from '../views/ArtistManage.vue'
import QueryLogManage from '../views/QueryLogManage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'Login', component: Login, meta: { public: true } },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true, title: '首页' }
  },
  {
    path: '/certificates',
    name: 'CertificateManage',
    component: CertificateManage,
    meta: { requiresAuth: true, title: '证书档案' }
  },
  {
    path: '/artists',
    name: 'ArtistManage',
    component: ArtistManage,
    meta: { requiresAuth: true, title: '鉴别艺人' }
  },
  {
    path: '/query-logs',
    name: 'QueryLogManage',
    component: QueryLogManage,
    meta: { requiresAuth: true, title: '查询记录' }
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.public) {
    next()
    return
  }
  if (!store.state.token) {
    next('/login')
    return
  }
  if (!store.state.userInfo) {
    try {
      const { meApi } = await import('../api/auth')
      const meRes = await meApi()
      store.commit('setUserInfo', meRes.data)
    } catch (e) {
      store.commit('clearAuth')
      next('/login')
      return
    }
  }
  next()
})

export default router
